import { useAuthGuard } from "../../useAuthGuard";
import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
// import moment from "moment";

// material-ui
import { styled, useTheme } from "@mui/material/styles";
import {
  AppBar,
  Box,
  CssBaseline,
  Grid,
  Toolbar,
  Typography,
  useMediaQuery,
} from "@mui/material";
import reactStyled from "styled-components";
import axios from "axios";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import SocketPanel from "../Customization/socket";
import { drawerWidth, gridSpacing } from "../../store/constant";

// project imports
// import OrderNtfZastand from "../../zastand/OrderNtf.zastand";
import Header from "./Header";
import Sidebar from "./Sidebar";
// import orderSocket from "../../orderSocket";
import { SET_MENU } from "../../store/actions";
import rightSideBarZastand from "../../zastand/rightSidePanel.zastand";
import rightSideBarZastandSocket from "../../zastand/rightSidePanelSocket.zastand";
import rightSideBarZastandRecent from "../../zastand/rightSidePanelRecent.zastand";
import { orderHost } from "../../Config";
// assets
import PerfectScrollbar from "react-perfect-scrollbar";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineOppositeContent, {
  timelineOppositeContentClasses,
} from "@mui/lab/TimelineOppositeContent";
import ConnectionStatus from "../../connectionStatus";
import role_axios from "../../views/utilities/rolesaxios";

// styles
const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    ...theme.typography.mainContent,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    transition: theme.transitions.create(
      "margin",
      open
        ? {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
          }
        : {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }
    ),
    [theme.breakpoints.up("md")]: {
      marginLeft: open ? 0 : -(drawerWidth - 20),
      width: `calc(100% - ${drawerWidth}px)`,
    },
    [theme.breakpoints.down("md")]: {
      marginLeft: "20px",
      width: `calc(100% - ${drawerWidth}px)`,
      padding: "16px",
    },
    [theme.breakpoints.down("sm")]: {
      marginLeft: "10px",
      width: `calc(100% - ${drawerWidth}px)`,
      padding: "16px",
      marginRight: "10px",
    },
  })
);

// ==============================|| MAIN LAYOUT ||============================== //

const RightSidebarNav = reactStyled.nav`
// position: fixed;
// background: #FEFBF6;
width: 20%;
height: 100%;
margin-top: 88px;
display : ${({ rightSidebar }) => (rightSidebar ? "flex" : "none")};
// justify-content: center;
// padding: .5rem;
overflow-y: scroll;
// overflow-x: scroll;
// margin-bottom: 2%;
// bottom: 0;  
// right: 0;
`;
// const RightSidebarNavSocket = reactStyled.nav`
// background: #FEFBF6;
// width: 20%;
// height: 100%;
// margin-top: 4%;
// display : ${({ rightSidebarSocket }) => (rightSidebarSocket ? "flex" : "none")};
// justify-content: center;
// // padding: .5rem;
// overflow-y: scroll;
// margin-bottom: 2%;
// `;
// const RightSidebarNavRecent = reactStyled.nav`
// background: #FEFBF6;
// width: 20%;
// height: 100%;
// margin-top: 4%;
// display : ${({ rightSidebarRecent }) => (rightSidebarRecent ? "flex" : "none")};
// justify-content: center;
// padding: .5rem;
// overflow-y: scroll;
// margin-bottom: 2%;
// `;

const RightSidebarWrap = reactStyled.div`
width: 100%;
height: 100%
display : flex;
// align-content: center;
flex-direction: column;
// margin-top : 1.3rem;
// margin-bottom : 1.3rem;
`;

const MainLayout = () => {
  // useEffect(() => {
  //   console.log("sss");
  //   alert(localStorage.getItem("token"));
  // });
  useAuthGuard(localStorage.getItem("token") || null, false);

  // const { orderNtf, setOrderftData } = OrderNtfZastand();
  const [, setTotalNtf] = useState(0);

  const rightSidebar = rightSideBarZastand((state) => state.rightSideBar);
  const rightSidebarSocket = rightSideBarZastandSocket(
    (state) => state.rightSideBarSocket || false
  );

  const rightSidebarRecent = rightSideBarZastandRecent(
    (state) => state.rightSideBarRecent
  );
  const [filter, setFilter] = React.useState("");

  const handleChange = (event) => {
    setFilter(event.target.value);
  };

  const theme = useTheme();
  const matchDownMd = useMediaQuery(theme.breakpoints.down("md"));
  const matchUpMd = useMediaQuery(theme.breakpoints.up("md"));

  // Handle left drawer
  const leftDrawerOpened = useSelector((state) => state.customization.opened);
  const dispatch = useDispatch();
  const handleLeftDrawerToggle = () => {
    dispatch({ type: SET_MENU, opened: !leftDrawerOpened });
  };

  const [pageLimit] = useState(6);
  // const fetchData = async () => {
  //   const jwtToken = localStorage.getItem("token");
  //   const url = orderHost + `/orders/ntf?limit=${pageLimit}&page=1`;
  //   const response = await axios.get(url, { headers: { token: jwtToken } });
  //   if (response && response.data.status === true) {
  //     // setOrderftData(response.data.data);
  //     setTotalNtf(response.data.total);
  //     localStorage.setItem("ordersCount", totalNtf);
  //   }
  // };

  const fetchData = useCallback(async () => {
    const jwtToken = localStorage.getItem("token");
    const url = orderHost + `/orders/ntf?limit=${pageLimit}&page=1`;
    try {
      const response = await axios.get(url, { headers: { token: jwtToken } });
      if (response && response.data.status === true) {
        setTotalNtf(response.data.total);
        localStorage.setItem("ordersCount", response.data.total);
      }
    } catch (error) {
      console.log("Error fetching data:", error);
    }
  }, [pageLimit]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // orderSocket.on("orders", (data) => {
  //   const newData = [data, ...orderNtf];
  //   setOrderftData(newData);
  //   setTotalNtf(totalNtf + 1);

  //   localStorage.setItem("ordersCount", totalNtf);
  // });

  // const findTimeDifference = (time) => {
  //   const providedDate = moment(time);
  //   const currentTime = moment();
  //   const difference = currentTime.diff(providedDate, "minutes");
  //   console.log(difference);
  //   return `${difference} min`;
  // };

  console.log(rightSidebarRecent);

  // permissionService.js

 


  return (
    <Box sx={{ display: "flex" }}>
      <ConnectionStatus />
      <CssBaseline />
      {/* header */}
      <AppBar
        enableColorOnDark
        position="fixed"
        color="inherit"
        elevation={0}
        sx={{
          bgcolor: theme.palette.background.default,
          transition: leftDrawerOpened
            ? theme.transitions.create("width")
            : "none",
        }}
      >
        <Toolbar>
          <Header handleLeftDrawerToggle={handleLeftDrawerToggle} />
        </Toolbar>
      </AppBar>

      {/* drawer */}
      <Sidebar
        drawerOpen={!matchDownMd ? leftDrawerOpened : !leftDrawerOpened}
        drawerToggle={handleLeftDrawerToggle}
      />

      {/* main content */}
      <Main theme={theme} open={leftDrawerOpened}>
        {/* breadcrumb */}
        {/* <Breadcrumbs
          separator={IconChevronRight}
          navigation={navigation}
          icon
          title
          rightAlign
        /> */}
        <Outlet />
      </Main>
      {/* <CustomizationSocket /> */}
      {/* <CustomizationRecent /> */}

      {/* socket panel start */}
      <RightSidebarNav rightSidebar={rightSidebarSocket}>
        {/* <PerfectScrollbar
          // component="div"
          style={{
            height: !matchUpMd ? "calc(100vh - 56px)" : "calc(100vh - 88px)",
            // paddingLeft: "16px",
            // paddingRight: "16px",
          }}
        > */}
        <RightSidebarWrap
          style={{
            height: !matchUpMd ? "calc(100vh - 56px)" : "calc(100vh - 88px)",
            // paddingLeft: "16px",
            paddingRight: "6px",
          }}
        >
          {/* <div style={{ display: "flex", alignItems: "center" }}>
            <h6>Socket123 </h6>
            <h6
              style={{
                backgroundColor: "#FFC107",
                padding: ".5rem",
                borderRadius: "1.5rem",
                marginLeft: "3%",
                color: "white",
              }}
            >
              {totalNtf}
            </h6>
          </div>  */}

          <SocketPanel />
        </RightSidebarWrap>
        {/* </PerfectScrollbar> */}
      </RightSidebarNav>
      {/* socket panel end */}

      {/* <RightSidebarNav rightSidebar={rightSidebarRecent}>
        <RightSidebarWrap>
          <PerfectScrollbar component="div">
            <Grid container spacing={gridSpacing} sx={{ p: 2 }}>
              <Grid item xs={12}>
                <Typography variant="h4" component="h2">
                  Recent Activity | Today
                </Typography>{" "}
                <br />
                <br />
                <Timeline
                  sx={{
                    [`& .${timelineOppositeContentClasses.root}`]: {
                      flex: 0.1,
                    },
                  }}
                >
                  <TimelineItem>
                    <TimelineOppositeContent color="textSecondary">
                      32 min
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                      <TimelineDot />
                      <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent>
                      Quia quae rerum explicabo officiisbeatae
                    </TimelineContent>
                  </TimelineItem>
                  <TimelineItem>
                    <TimelineOppositeContent color="textSecondary">
                      56 min
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                      <TimelineDot />
                      <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent>
                      Voluptatem blanditiis blanditiis eveniet
                    </TimelineContent>
                  </TimelineItem>
                  <TimelineItem>
                    <TimelineOppositeContent color="textSecondary">
                      56 min
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                      <TimelineDot />
                    </TimelineSeparator>
                    <TimelineContent>
                      Voluptatem blanditiis blanditiis eveniet
                    </TimelineContent>
                  </TimelineItem>
                </Timeline>
              </Grid>
            </Grid>
          </PerfectScrollbar>
        </RightSidebarWrap>
      </RightSidebarNav> */}
    </Box>
  );
};

export default MainLayout;
